import { User } from '@features/user';
import { StoreDetail } from '@mdfrontw/core';

export interface GA4UserGroup {
    im_user_status: string;
    im_user_type: string;
    im_user_email_sha256_1: string;
    im_user_email_sha256_2: string;
    im_user_client_type: string;
    im_user_id: string;
    im_store_id: string;
    im_user_client_id: string;
}

export enum YesOrNoTypeString {
    si = 'si',
    no = 'no',
}

export enum UserTypeString {
    registrado = 'registrado',
}

export enum UserClientTypeString {
    empresa = 'empresa',
    particular = 'particular',
}

export interface GA4UserValues {
    user: User;
    store?: StoreDetail;
    gaCookie: string;
}
